<template>
    <div>
        <section class="container mt-3 py-3">
            <h4>Loader SIAHE</h4>
            <kurama-loader v-if="load" msj="Cargando información" />
            
            <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación del componente loader</p>
            <div v-highlight>
        <pre class="language-html pt-0 px-0"><code><script type="text/plain" class="language-markup">
            <kurama-loader
                v-if="load"
                msj="Cargando información"
            />
    </script></code></pre></div>


            <div class="mt-5 mb-3">
            <h5>Atributos del componente loader</h5>
                <table class="table" style="font-size:.8rem;">
                    <thead>
                        <tr>
                        <th scope="col">Propiedad</th>
                        <th scope="col">Atributo</th>
                        <th scope="col">Descripción</th>
                        </tr>
                    </thead>
                    <tbody class="table-group-divider">
                        <tr v-for="(item, index) in descripcion" :key="index">
                        <th scope="row"> <code>{{item.propiedad}}</code> </th>
                        <td style="font-size:.7rem;">{{item.atributo}}</td>
                        <td>{{item.descripcion}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="my-3">
                <vs-button @click="load=true, ejecucionLoad()" class="btn-primary"> Ver load </vs-button>
            </div>
            <!-- <div class="my-3">
                <vs-button @click="login = true" class="btn-tertiary"> login </vs-button>
                <login-component 
                v-if="login" 
                :msj="2"
                @login="login = $event"
                >
                </login-component> 
            </div> -->
        </section>
    </div>
</template>
<script>
import loginComponent from '@/components/loginComponent/PxLogin.vue'
export default({
    name: 'loader',
    components: {
        loginComponent
    },
    data: function() {
        return{
            login: false,
            load: true,
            descripcion: [
                {'propiedad': 'v-if', 'atributo': 'Condicional', 'descripcion': 'Activa o desactiva el loader' },
                { 'propiedad': 'msj', 'atributo': 'String', 'descripcion': 'Leyenda del loader' },
                
            ]
        }
    },
    created(){
        this.ejecucionLoad(),
        window.scrollTo(0, 0);
    },
    methods: {
        ejecucionLoad(){
            setTimeout( () => {this.load = false}, 2000);
        },

    }
})
</script>
